export enum eParentChangeBehavior {
    PRESERVE_POSITION,
    PRESERVE_PROPERTY,
}
export interface KbViewerSettings {
    parentChangeBehavior: eParentChangeBehavior;
}
